import React from "react";
import { useTranslation } from "react-i18next";
import "./LineItemTable.css";

const formatCAD = (amount) =>
    new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD",
    }).format(amount ?? 0);

const LineItemTable = ({
    items = [],
    editable = false,
    services = [],
    onItemChange,
    onAddItem,
    onRemoveItem,
}) => {
    const { t } = useTranslation();

    return (
        <div className="line-item-table">
            <table className="line-item-table__table">
                <thead>
                    <tr>
                        {editable && (
                            <th className="line-item-table__th line-item-table__th--service">
                                {t("lineItem.selectService")}
                            </th>
                        )}
                        <th className="line-item-table__th line-item-table__th--desc">
                            {t("lineItem.description")}
                        </th>
                        <th className="line-item-table__th line-item-table__th--num">
                            {t("lineItem.qty")}
                        </th>
                        <th className="line-item-table__th line-item-table__th--num">
                            {t("lineItem.unitPrice")}
                        </th>
                        <th className="line-item-table__th line-item-table__th--num">
                            {t("lineItem.subtotal")}
                        </th>
                        {editable && (
                            <th className="line-item-table__th line-item-table__th--action"></th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr
                            key={item.id || index}
                            className="line-item-table__row"
                        >
                            {editable && (
                                <td className="line-item-table__td">
                                    <select
                                        className="line-item-table__select"
                                        value={item.service_id || ""}
                                        onChange={(e) => {
                                            const svc = services.find(
                                                (s) =>
                                                    String(s.id) ===
                                                    e.target.value,
                                            );
                                            onItemChange(index, {
                                                service_id: e.target.value,
                                                description: svc
                                                    ? svc.name
                                                    : item.description,
                                                unit_price: svc
                                                    ? svc.default_price_cad
                                                    : item.unit_price,
                                            });
                                        }}
                                    >
                                        <option value="">— custom —</option>
                                        {services.map((s) => (
                                            <option key={s.id} value={s.id}>
                                                {s.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            )}
                            <td className="line-item-table__td">
                                {editable ? (
                                    <input
                                        className="line-item-table__input"
                                        value={item.description}
                                        onChange={(e) =>
                                            onItemChange(index, {
                                                description: e.target.value,
                                            })
                                        }
                                        placeholder={t("lineItem.description")}
                                    />
                                ) : (
                                    <span>{item.description}</span>
                                )}
                            </td>
                            <td className="line-item-table__td line-item-table__td--num">
                                {editable ? (
                                    <input
                                        className="line-item-table__input line-item-table__input--num"
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        value={item.qty}
                                        onChange={(e) =>
                                            onItemChange(index, {
                                                qty:
                                                    parseFloat(
                                                        e.target.value,
                                                    ) || 1,
                                            })
                                        }
                                    />
                                ) : (
                                    <span>{item.qty}</span>
                                )}
                            </td>
                            <td className="line-item-table__td line-item-table__td--num">
                                {editable ? (
                                    <input
                                        className="line-item-table__input line-item-table__input--num"
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={item.unit_price}
                                        onChange={(e) =>
                                            onItemChange(index, {
                                                unit_price:
                                                    parseFloat(
                                                        e.target.value,
                                                    ) || 0,
                                            })
                                        }
                                    />
                                ) : (
                                    <span>{formatCAD(item.unit_price)}</span>
                                )}
                            </td>
                            <td className="line-item-table__td line-item-table__td--num line-item-table__td--subtotal">
                                {formatCAD(item.qty * item.unit_price)}
                            </td>
                            {editable && (
                                <td className="line-item-table__td line-item-table__td--action">
                                    <button
                                        type="button"
                                        className="line-item-table__remove"
                                        onClick={() => onRemoveItem(index)}
                                        title={t("lineItem.remove")}
                                    >
                                        ×
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>

            {editable && (
                <button
                    type="button"
                    className="line-item-table__add-btn"
                    onClick={onAddItem}
                >
                    + {t("lineItem.addItem")}
                </button>
            )}
        </div>
    );
};

export default LineItemTable;
